/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import AuditingLogAPI from '@/api/AuditingLogAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
export default {
	loadAuditingLogs: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: AuditingLogAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
			params: payload
		});
		if (res && res.Success) {
			context.commit('updateAuditingLogs', res.Data);
		}
		return null;
	}
};
